module.exports = __webpack_public_path__ + "9af1c775255a1398fbe4a133dfefe9f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_08.jpg
// module id = 628
// module chunks = 0